import config from '../../../assets/js/conf/config';
import md5 from 'js-md5';
import { getCommunityData, getIndexData, getDetailsData } from "../../../api/index";

export default {
  namespaced: true,
  state: {
    bannerList: [],
    goodList: [],
    detail: {},
    community: [],
    communityIsShow: true,
  },
  mutations: {
    ["SET_BANNER"](state, payload) {
      // 获取值并提交到state VUEX缓存中
      state.bannerList = payload.banner;

    },
    ["SET_GOODS"](state, payload) {
      // 获取值并提交到state VUEX缓存中
      state.goodList = payload.goods;

    },
    ["SET_DETAILS"](state, payload) {
      // 获取值并提交到state VUEX缓存中
      state.detail = payload.detail;

    },

    ["SET_COMMUNITY"](state, payload) {
      state.community = payload.data;
    },


    ["SET_COMMUNITY_IS_SHOW"](state, payload) {
      state.communityIsShow = payload.communityIsShow;
    },



  },
  actions: {

    //社区客服
    getCommunity(conText, payload) {

      // console.log(res)
      let communityKey = config.communityKey;
      let time = new Date().getTime().toString();

      // console.log(communityKey)
      // console.log(time)

      let token = md5(md5(time) + '|' + communityKey);
      let data = {
        time,
        token,
      }
      getCommunityData(JSON.stringify(data)).then(res => {
        // console.log(res)

        if (res.status == 1) {
          conText.commit("SET_COMMUNITY", { data: res.data });
          // conText.commit("SET_GOODS",{goods:res.data.goods});
        }

      })

    },

    //首页轮播图
    getIndex(conText, payload) {

      // console.log(res)
      let honeKey = config.honeKey;
      let time = new Date().getTime().toString();

      // console.log(honeKey)
      // console.log(time)

      let token = md5(md5(time) + '|' + honeKey);
      let data = {
        time,
        token,
      }
      getIndexData(JSON.stringify(data)).then(res => {
        // console.log(res)

        if (res.status == 1) {
          conText.commit("SET_BANNER", { banner: res.data.banner });
          conText.commit("SET_GOODS", { goods: res.data.goods });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },



    getDetails(conText, payload) {

      // console.log(res)
      let honeKey = config.honeKey;
      let time = new Date().getTime().toString();
      let slide_id = payload.id;

      // console.log(honeKey)
      // console.log(time)

      let token = md5(md5(time + '|' + slide_id) + '|' + honeKey);
      let data = {
        time,
        token,
        slide_id: slide_id
      }
      getDetailsData(JSON.stringify(data)).then(res => {
        console.log(res)

        if (res.status == 1) {
          conText.commit("SET_DETAILS", { detail: res.data });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },


    // getGoods(conText,payload){
    //     getGoodsData().then(res=>{
    //         if(res.code === 200){                    
    //             // commit 将值提交到mutations中
    //             conText.commit("SET_GOODS",{good:res.data});
    //             console.log(res)
    //             if(payload.success){
    //                 payload.success();
    //             }

    //         }
    //     })
    // }
  }
}